import React, { useState, useContext, useEffect } from "react";
import { ManageMapperLayout } from "../../../components";
import RACTile from "./RACTile";
import "./sample.css";
import { get, isEmpty } from "lodash";
import { MANAGE_MAPPER_ROUTES, ROUTES, getPathWithParam } from "../../../utils";
import { manageMapperStore } from "../../../contexts";
import { cloneProfile } from "../../../services";
import { Formik } from "formik";
import AddToolTip from "../../../components/AddToolTip";
import { useRouterParams } from "../../../abstracts";
import {
  getOutputTargetType,
  getFileFormat,
  getDataModel,
} from "../OverviewContainer/OverviewContainer";

const ReviewAndConfirmContainer = (props) => {
  const { history } = props;
  const initialValues = {
    cloneProfileName: "",
  };
  const { state, dispatch } = useContext(manageMapperStore);
  const data =
    get(state, "api.fileuploadData.mappingConfiguration") ||
    get(state, "api.data", {});
  const headersJson = get(data, "headerMapJson");
  const fileuploadData = JSON.stringify(
    get(state, "api.fileuploadData.row", [])
  );
  const fileUpload = get(state, "api.fileuploadData", []);
  const fieldHeadersJson = isEmpty(fileUpload) ? headersJson : fileuploadData;
  const basicInformation = get(state, "basicInformation", []);
  const sourceLength =
    !isEmpty(fieldHeadersJson) && JSON.parse(fieldHeadersJson).length;
  const a = get(data, "objectMaps")?.map((_) => {
    if (!isEmpty(_.childObjectMaps)) {
      return _.childObjectMaps.length;
    } else return 0;
  });

  const childObjectMaps = a?.reduce((a, b) => a + b, 0);
  const objCount =
    !isEmpty(data) &&
    get(data, "objectMaps")?.filter(
      (obj) => isEmpty(obj.parent) && isEmpty(obj.childObjectMaps)
    );
  const [isActive, setisActive] = useState();
  const profileId = get(state, "api.data.id");
  const { mapType } = useRouterParams();
  const [aggregateInfoString, setAggregateInfoString] = useState();
  const [dupStrategy, setDupStrategy] = useState();
  const [customLogics, setCustomLogics] = useState();
  const [keyFields, setKeyFields] = useState();
  const objectMaps = !isEmpty(data) && get(data, "objectMaps", []);
  const [countTransforms, setCountTransforms] = useState(0);
  const configJsonString = get(data, "configurationJson", "{}");
  const configJson = JSON.parse(configJsonString);
  const profileName = !isEmpty(data) && get(data, "name");
  const numPlans =
    !isEmpty(data) &&
    (mapType == 1
      ? get(data, "planProfiles", 0)
      : get(data, "outputPlanProfiles", 0));
  const filterjson = data.filterObjectJson && JSON.parse(data.filterObjectJson);
  const A =
    mapType == 1 ? filterjson?.filter((x) => x.selected == true) : filterjson;

  useEffect(() => {
    if (!isEmpty(data)) {
      setisActive(get(data, "isActive"));
      if (data.isAggregationModel) {
        let c = 0;
        const aggregateInfo = get(data, "aggregationModelJson");
        setAggregateInfoString(aggregateInfo);
        const aggregateInfoJson = JSON.parse(aggregateInfo);
        setDupStrategy(aggregateInfoJson.aggregationStrategy);
        aggregateInfoJson.aggregationOperationEntities.map((item) => {
          if (!isEmpty(item.operation)) {
            c = c + 1;
          }
        });
        setCustomLogics(c);
        setKeyFields(aggregateInfoJson.aggregationEntites.length);
      }
      let count = 0;
      objectMaps.map((item) => {
        if (!isEmpty(item.fieldOperations)) {
          count = count + 1;
        }
      });
      setCountTransforms(count);
    }
  }, [data]);

  const onSubmit = () => {
    // onUpdateStatus({ ...data, isActive: isActive })
    //   .then((res) => {
    //     if (!isEmpty(res)) {
    //       history.push(`${ROUTES.MAPPER_HOME}`);
    //     }
    //   })
    //   .catch((err) => err);

    history.push(`${ROUTES.MAPPER_HOME}`);
  };

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: ROUTES.MAPPER_HOME,
    },
    {
      label: "Confirm",
      variant: "primary",
      type: "button",
      onClick: onSubmit,
    },
  ];

  return (
    <Formik initialValues={initialValues}>
      {({ values, setFieldValue, setSubmitting }) => {
        const onCloneProfile = (id, name) => {
          setSubmitting(true);
          cloneProfile(id, name)
            .then(() => {
              history.push(`${ROUTES.MAPPER_HOME}`);
            })
            .catch((err) => {
              return err;
            });
        };
        return (
          <ManageMapperLayout
            buttons={buttons}
            layoutHeader={"Review & Confirm"}
          >
            {/* <pre>{JSON.stringify(configJson, null, 2)}</pre> */}

            <div
              // style={{ marginTop: "3.125rem" }}
              className="mapper-raccontainer-grid2"
            >
              {mapType == 1 ||
                (mapType == 3 && (
                  <RACTile
                    profileId={profileId}
                    tileRoute={`${MANAGE_MAPPER_ROUTES.SOURCE}`}
                    title="Source"
                    height="9.188rem"
                    mapType={mapType}
                  >
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      Source Name
                    </div>

                    <AddToolTip name={data.name}>
                      <div
                        className="text-overflow-elipsis"
                        style={{ fontSize: "14px", width: "220px" }}
                      >
                        {data.name}
                      </div>
                    </AddToolTip>
                    {mapType == 3 ? (
                      <>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Source Format
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          {getFileFormat(data?.format)}
                        </div>
                      </>
                    ) : (
                      <>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Source Type
                        </div>
                        <div style={{ fontSize: "14px" }}>File</div>
                      </>
                    )}
                    {data?.format == 1 && (
                      <>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Delimiter
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          {configJson?.delimiter}
                        </div>
                      </>
                    )}
                    {data?.format == 2 && (
                      <>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Record Length
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          {configJson?.recordLength}
                        </div>
                      </>
                    )}
                    {data?.format != 2 && (
                      <>
                        <div style={{ fontSize: "12px", color: "grey" }}>
                          Has Header
                        </div>
                        <div style={{ fontSize: "14px" }}>
                          {configJson?.hasHeader ? "Yes" : "No"}
                        </div>
                      </>
                    )}
                    {mapType == 1 ? (
                      <AddToolTip name={data.fileName}>
                        <div
                          className="text-overflow-elipsis"
                          style={{ fontSize: "14px", width: "220px" }}
                        >
                          {data.fileName}
                        </div>
                      </AddToolTip>
                    ) : null}
                  </RACTile>
                ))}

              {mapType == 3 && (
                <RACTile
                  profileId={profileId}
                  tileRoute={`${MANAGE_MAPPER_ROUTES.PASSTHROUGH_TARGET}`}
                  title="Target"
                  height="9.188rem"
                  mapType={mapType}
                >
                  <div style={{ fontSize: "12px", color: "grey" }}>
                    Target Name
                  </div>
                  <AddToolTip name={data.name}>
                    <div
                      className="text-overflow-elipsis"
                      style={{ fontSize: "14px", width: "220px" }}
                    >
                      {data.targetFileName}
                    </div>
                  </AddToolTip>
                  <div style={{ fontSize: "12px", color: "grey" }}>
                    Target Type
                  </div>
                  <div style={{ fontSize: "14px" }}>
                    {data.isCOREDCProfile ? "Core" : "File"}
                  </div>
                  <div style={{ fontSize: "12px", color: "grey" }}>
                    Has Header
                  </div>
                  <div style={{ fontSize: "14px" }}>
                    {data?.hasHeader ? "Yes" : "No"}
                  </div>
                  {data.isCOREDCProfile ? (
                    <>
                      <div style={{ fontSize: "12px", color: "grey" }}>
                        FTP URL
                      </div>
                      <div style={{ fontSize: "14px" }}>-</div>
                      <div style={{ fontSize: "12px", color: "grey" }}>
                        FTP Path
                      </div>
                      <div style={{ fontSize: "14px" }}>-</div>
                    </>
                  ) : null}
                </RACTile>
              )}

              {mapType == 2 && (
                <RACTile
                  profileId={profileId}
                  tileRoute={`${MANAGE_MAPPER_ROUTES.OUTPUT_TARGET}`}
                  title="Target"
                  height="9.188rem"
                  mapType={mapType}
                >
                  <div style={{ fontSize: "12px", color: "grey" }}>
                    File Name
                  </div>

                  <AddToolTip name={data.name}>
                    <div
                      className="text-overflow-elipsis"
                      style={{ fontSize: "14px", width: "220px" }}
                    >
                      {data.name}
                    </div>
                  </AddToolTip>
                  <div style={{ fontSize: "12px", color: "grey" }}>
                    File format
                  </div>
                  <div style={{ fontSize: "14px" }}>
                    {getFileFormat(data?.format)}
                  </div>
                  {data?.format == 1 && (
                    <>
                      <div style={{ fontSize: "12px", color: "grey" }}>
                        Delimiter
                      </div>
                      <div style={{ fontSize: "14px" }}>{data?.delimiter}</div>
                    </>
                  )}
                  {data?.format == 2 && (
                    <>
                      <div style={{ fontSize: "12px", color: "grey" }}>
                        Record Length
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        {data?.recordLength}
                      </div>
                    </>
                  )}
                  {data?.format != 2 && (
                    <>
                      <div style={{ fontSize: "12px", color: "grey" }}>
                        Has Header
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        {data?.hasHeader ? "Yes" : "No"}
                      </div>
                    </>
                  )}
                  <div style={{ fontSize: "12px", color: "grey" }}>
                    Has Encryption
                  </div>
                  <div style={{ fontSize: "14px" }}>
                    {data?.hasEncryption ? "Yes" : "No"}
                  </div>
                </RACTile>
              )}

              {mapType == 1 || mapType == 2 ? (
                <RACTile
                  profileId={profileId}
                  tileRoute={`${MANAGE_MAPPER_ROUTES.BASIC_INFORMATION}`}
                  title="Plan association"
                  mapType={mapType}
                >
                  <div style={{ fontSize: "12px", color: "grey" }}>
                    Number of plans associated
                  </div>
                  <div style={{ fontSize: "14px", marginBottom: "1.563rem" }}>
                    {numPlans?.length}
                  </div>
                </RACTile>
              ) : null}

              {mapType == 1 && (
                <RACTile
                  profileId={profileId}
                  tileRoute={`${MANAGE_MAPPER_ROUTES.AGGREGATE}`}
                  title="Manage duplicates"
                  mapType={mapType}
                >
                  <div>
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      Duplication Strategy used
                    </div>
                    <div style={{ fontSize: "14px" }}>{dupStrategy ?? "-"}</div>
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      Number of fields with custom logics applied
                    </div>
                    <div style={{ fontSize: "14px" }}>
                      {customLogics ?? "-"}
                    </div>
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      Number of key fields used
                    </div>
                    <div style={{ fontSize: "14px" }}>{keyFields ?? "-"}</div>
                  </div>
                </RACTile>
              )}

              {mapType == 1 && (
                <RACTile
                  profileId={profileId}
                  tileRoute={`${MANAGE_MAPPER_ROUTES.TARGET}`}
                  title="Target"
                  mapType={mapType}
                >
                  <div style={{ fontSize: "12px", color: "grey" }}>
                    Target Type
                  </div>
                  <div style={{ fontSize: "14px" }}>-</div>
                  <div style={{ fontSize: "12px", color: "grey" }}>
                    File Type
                  </div>
                  <div style={{ fontSize: "14px" }}>-</div>
                  <div style={{ fontSize: "12px", color: "grey" }}>FTP URL</div>
                  <div style={{ fontSize: "14px" }}>-</div>
                  <div style={{ fontSize: "12px", color: "grey" }}>
                    FTP Path
                  </div>
                  <div style={{ fontSize: "14px" }}>-</div>
                </RACTile>
              )}

              {mapType == 2 && (
                <RACTile
                  profileId={profileId}
                  tileRoute={`${MANAGE_MAPPER_ROUTES.OUTPUT_TARGET}`}
                  title="FTPDetails"
                  mapType={mapType}
                >
                  <div style={{ fontSize: "12px", color: "grey" }}>
                    Target Type
                  </div>
                  <div style={{ fontSize: "14px" }}>
                    {getOutputTargetType(data?.sourceType)}
                  </div>
                  <div style={{ fontSize: "12px", color: "grey" }}>FTP URL</div>
                  <div style={{ fontSize: "14px" }}>
                    {data?.ftpChannel?.url ?? "-"}
                  </div>
                  <div style={{ fontSize: "12px", color: "grey" }}>
                    FTP Path
                  </div>
                  <div style={{ fontSize: "14px" }}>
                    {data?.ftpChannel?.filePath ?? "-"}
                  </div>
                </RACTile>
              )}

              <RACTile
                profileId={profileId}
                tileRoute={
                  mapType == 1 || mapType == 3
                    ? `${MANAGE_MAPPER_ROUTES.MAP_AND_TRANSFORM}`
                    : `${MANAGE_MAPPER_ROUTES.MAP_AND_TRANSFORM_OUTPUT}`
                }
                title="Map & transform"
                mapType={mapType}
              >
                <div
                  style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}
                >
                  {mapType == 1 || mapType == 3 ? (
                    <div>
                      <div style={{ fontSize: "14px" }}>Source Fields</div>
                      <div
                        style={{
                          fontSize: "24px",
                          color: "orange",
                          marginBottom: "1.563rem",
                        }}
                      >
                        {sourceLength}
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div style={{ fontSize: "14px" }}>Data Model</div>
                      <div
                        style={{
                          fontSize: "16px",
                          color: "orange",
                          marginBottom: "1.563rem",
                        }}
                      >
                        {getDataModel(data?.dataModel)}
                      </div>
                    </div>
                  )}
                  <div>
                    <div style={{ fontSize: "14px" }}>Mapped Fields</div>
                    <div style={{ fontSize: "24px", color: "green" }}>
                      {mapType == 1
                        ? objCount?.length + childObjectMaps
                        : mapType == 3
                        ? get(data, "passthroughObjectMaps")?.length
                        : get(data, "mappingObjectMaps")?.length}
                    </div>
                  </div>
                  {mapType != 2 && (
                    <div>
                      <div style={{ fontSize: "14px" }}>Transformed</div>
                      <div style={{ fontSize: "24px", color: "purple" }}>
                        {countTransforms}
                      </div>
                    </div>
                  )}
                </div>
              </RACTile>

              {mapType == 3 ? (
                <RACTile
                  profileId={profileId}
                  tileRoute={`${MANAGE_MAPPER_ROUTES.VALIDATIONS}`}
                  title="Validations"
                  mapType={mapType}
                >
                  <div style={{ fontSize: "12px", color: "grey" }}>
                    Number of Rules Configured
                  </div>
                  <div style={{ fontSize: "14px", marginBottom: "1.563rem" }}>
                    0
                  </div>
                </RACTile>
              ) : null}

              <RACTile
                profileId={profileId}
                tileRoute={
                  mapType == 1
                    ? `${MANAGE_MAPPER_ROUTES.FILTER}`
                    : `${MANAGE_MAPPER_ROUTES.OUTPUT_FILTER}`
                }
                title="Filter"
                mapType={mapType}
              >
                <div style={{ fontSize: "12px", color: "grey" }}>
                  Number of Filter conditions used
                </div>
                <div style={{ fontSize: "14px", marginBottom: "1.563rem" }}>
                  {A?.length ?? 0}
                </div>
              </RACTile>

              {mapType == 1 && (
                <>
                  <RACTile
                    profileId={profileId}
                    tileRoute={`${MANAGE_MAPPER_ROUTES.RULESET}`}
                    title="Ruleset"
                    mapType={mapType}
                  >
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      Ruleset Name
                    </div>
                    <div style={{ fontSize: "14px", marginBottom: "1.563rem" }}>
                      -
                    </div>
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      Number of Rules Configured
                    </div>
                    <div style={{ fontSize: "14px" }}>-</div>
                  </RACTile>

                  <RACTile
                    profileId={profileId}
                    tileRoute={`${MANAGE_MAPPER_ROUTES.SCHEDULER}`}
                    title="Schedule"
                    mapType={mapType}
                  >
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      Import via
                    </div>
                    <div style={{ fontSize: "14px", marginBottom: "1.563rem" }}>
                      FTP-
                    </div>
                    <div style={{ fontSize: "12px", color: "grey" }}>
                      Frequency
                    </div>
                    <div style={{ fontSize: "14px" }}>-</div>
                  </RACTile>
                </>
              )}
            </div>
          </ManageMapperLayout>
        );
      }}
    </Formik>
  );
};

export default ReviewAndConfirmContainer;
